import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { MedicalCardsState, MedicalCardsStore } from './medicalCards.store';

@Injectable({ providedIn: 'root' })
export class MedicalCardsQuery extends QueryEntity<MedicalCardsState> {

  constructor(protected store: MedicalCardsStore) {
    super(store);
  }
}
